import { Injectable } from '@angular/core';
import { AppSettingsDto } from './api.services';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LocalisationService {

  // Requirements are to have a different format for Japanese locale than the rest
  // If adding a new custom date format consider Japanese format
  // Add mapping to mapToJapaneseFormat function
  CUSTOM_DATE_FORMATS = {
    mediumDate: 'MMM dd, yyyy',
    mediumDateTimeNoSeconds: 'MMM dd, yyyy HH:mm',
    mediumDateTimeWithSeconds: 'MMM dd, yyyy HH:mm:ss',
    japanMediumDate: 'yyyy/MM/dd',
    japanMediumDateTimeNoSeconds: 'yyyy/MM/dd HH:mm',
    japanMediumDateTimeWithSeconds: 'yyyy/MM/dd HH:mm:ss',
  };

  mapToJapaneseFormat(formatString: string): string {
    switch(formatString) {
      case this.CUSTOM_DATE_FORMATS.mediumDate:
        formatString = this.CUSTOM_DATE_FORMATS.japanMediumDate;
        break;
      case this.CUSTOM_DATE_FORMATS.mediumDateTimeNoSeconds:
        formatString = this.CUSTOM_DATE_FORMATS.japanMediumDateTimeNoSeconds;
        break;
      case this.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds:
        formatString = this.CUSTOM_DATE_FORMATS.japanMediumDateTimeWithSeconds;
        break;
    }

    return formatString;
  }

  getTimeZoneAbv(settings: AppSettingsDto): string {
    const abv = moment.tz(new Date(), settings.timeZoneIana).zoneAbbr();
    if (/^[-+]?[0-9]+/.test(abv))
      return 'UTC' + abv

    return abv;
  }
}
